import { createStandardAction } from 'typesafe-actions';

const TOGGLE = 'drawer/TOGGLE';

export const toggle = createStandardAction(TOGGLE)<boolean>();



// WEBPACK FOOTER //
// ./src/store/modules/drawer/actions.ts